import SET_IS_LOCKED from './constants';

const defaultState = {
    isLocked: false,
};

const isLockedUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_IS_LOCKED:
            return { ...state, isLocked: action.isLocked };

        default:
            return state;
    }
};

export default isLockedUI;



// WEBPACK FOOTER //
// ./src/containers/IsLocked/reducer.js